import { Bag, addProduct, createBag } from "@repo/apis/bag";
import { setBagCookies } from "../utils/bag-cookies";
import { handleApiInteractionError } from "../utils/handle-api-interaction-error";
import { BagSdkMethod } from "../utils/method-initialiser";

type PublicAddProductMethod = (params: { variantId: number }) => Promise<Bag>;
type AddProductMethod = BagSdkMethod<PublicAddProductMethod>;

export const addProductInitialiser: AddProductMethod =
  (context) =>
  async ({ variantId }) => {
    const {
      chameleonRequestInstance,
      store,
      lang,
      getAuthHeaderPredicate,
      customerId,
      keyStoreDataversion,
      currency,
      sizeSchema,
      country,
      originCountry,
      shop,
      state,
    } = context;

    const authHeader = await getAuthHeaderPredicate();
    let bag = state.getBag();
    let bagSessionToken = state.getBagSessionToken();
    const bagExpansions = state.getBagExpansions();

    if (!bag) {
      const createdBag = await createBag({
        chameleonRequestInstance,
        customerId,
        store,
        lang,
        keyStoreDataversion,
        authHeader,
        currency,
        sizeSchema,
        country,
        originCountry,
        shop,
        expand: bagExpansions,
      });

      bag = createdBag.data.bag;
      bagSessionToken = createdBag.bagSessionToken;

      state.setBag(bag);
      state.setBagSessionToken(bagSessionToken);

      setBagCookies(context, {
        bagId: bag.id,
        bagOrigin: bag.origin,
        sessionToken: bagSessionToken,
      });
    }

    const bagId = bag.id;

    try {
      const addProductResult = await addProduct({
        chameleonRequestInstance,
        variantId,
        store,
        lang,
        authHeader,
        asosBagSessionToken: bagSessionToken as string,
        bagId,
        expand: bagExpansions,
      });

      state.setBag(addProductResult.data.bag);
      state.setBagSessionToken(addProductResult.bagSessionToken);

      return addProductResult.data.bag;
    } catch (error: unknown) {
      return handleApiInteractionError(error);
    }
  };
